// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/WizardServicos_FinalizaCompromissoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for wizard_servicos/finaliza_compromisso
 *
 * Primitive dados: message string
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type WizardServicos_FinalizaCompromissoResponseDados = string;

export type WizardServicos_FinalizaCompromissoResponse = ApiResponse<WizardServicos_FinalizaCompromissoResponseDados>;

registerResponseContract('WizardServicos_FinalizaCompromissoResponse', {})
